import { render, staticRenderFns } from "./Echarts.vue?vue&type=template&id=e1a894ce&"
import script from "./Echarts.vue?vue&type=script&lang=js&"
export * from "./Echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../bigHealth/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports